// Cookie consent (GDPR): analytics/marketing scripts load ONLY after explicit accept.
const KEY = "cfm_cookie_consent"; // "accepted" | "rejected" | null (undecided)

export const getConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};
export const analyticsAllowed = () => getConsent() === "accepted";

export function setConsent(v) {
  try { localStorage.setItem(KEY, v); } catch { /* noop */ }
  if (v === "accepted") loadAnalytics();
  window.dispatchEvent(new Event("cfm-consent-changed"));
}

let _loaded = false;

export function loadAnalytics() {
  if (_loaded || typeof document === "undefined" || getConsent() !== "accepted") return;
  _loaded = true;

  // Google Analytics 4 (gtag)
  const ga = document.createElement("script");
  ga.async = true;
  ga.src = "https://www.googletagmanager.com/gtag/js?id=G-PLYFZ4ZQSV";
  document.head.appendChild(ga);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", "G-PLYFZ4ZQSV");

  // Meta Pixel
  (function (f, b, e, v) {
    let n, t, s;
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", "879643131717911");
  window.fbq("track", "PageView");

  // PostHog
  (function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); });
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e;
            },
            u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
            o = "init capture register register_once register_for_session unregister opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException debug identify setPersonProperties group reset".split(" "),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);
  window.posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
  });
}
